import { render, staticRenderFns } from "./router-view-wrapper.vue?vue&type=template&id=459048f3&"
import script from "./router-view-wrapper.vue?vue&type=script&lang=ts&"
export * from "./router-view-wrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports